export default {
  tokens: void (0)
}
